import Skeleton from '@carvana/ds-skeleton';
import { LoadingTile } from '@carvana/merch-tile';
import cx from 'classnames';
import LiveAnnouncer from '@/common/LiveAnnouncer';

type OwnProps = {
  hasBottomBorder?: boolean;
  hasGutterPadding?: boolean;
  tileCount?: number;
};

export default function LoadingVehicleCarousel({
  hasBottomBorder = false,
  hasGutterPadding = true,
  tileCount = 4
}: OwnProps) {
  return (
    <div
      className={cx('min-w-0 xl:max-w-[1352px]', {
        'lg:px-4xl': hasGutterPadding
      })}
      data-testid="loading-vehicle-carousel"
    >
      <LiveAnnouncer message="Loading vehicles" />
      {/* header */}
      <div
        className={cx({
          'px-2xl sm:px-4xl md:px-3xl lg:px-0': hasGutterPadding
        })}
      >
        <Skeleton height="28px" width="200px" />
      </div>

      <div
        className={cx('mt-3xl flex gap-2xl overflow-hidden', {
          'px-2xl sm:px-4xl md:px-3xl lg:px-0': hasGutterPadding
        })}
      >
        {Array.from({ length: tileCount }).map((_, index) => (
          <div
            key={index}
            className="w-[300px] shrink-0 sm:w-[280px] lg:w-[300px]"
          >
            <LoadingTile />
          </div>
        ))}
      </div>

      {/* pagination dots */}
      <div className="mt-3xl flex justify-center">
        <Skeleton height="7px" width="80px" className="rounded-full" />
      </div>
      {hasBottomBorder && (
        <div
          className={cx(
            'my-2xl border-b border-b-border-subtle sm:my-3xl',
            hasGutterPadding ? 'mx-2xl sm:mx-4xl md:mx-3xl lg:mx-0' : 'mx-0'
          )}
        />
      )}
    </div>
  );
}
